import React, {Component} from 'react';
import {connect} from 'react-redux';
import PostedApplicationPage from "../components/postedApplicationPage";
import { push } from 'connected-react-router'
import {changeApplicationsAndPoliciesField} from "../actions/applicationsAndPolicies";
import {getApplicationPolicyIPID, getApplicationPolicyWording} from "../actions/applicationPolicy";
import {getPostedApplicationMessage} from "../actions/submittedPolicy";


class PostedApplicationPageHOC extends Component {

    componentDidMount(){
        this.props.getApplicationPolicyWording({wordingId: this.props.postedApplicationPage.postedApplication.wordingId})
        this.props.getApplicationPolicyIPID({policyId: this.props.postedApplicationPage.postedApplication.id})
        this.props.getPostedApplicationMessage({applicationId:this.props.postedApplicationPage.postedApplication.id})
    }

    shouldRender = () =>{
        let app = this.props.postedApplicationPage.postedApplication;
        let pathname = this.props.router.location.pathname;

        if(app.hasOwnProperty('id')){
            if(pathname.includes(app.id.toString())){
                return true;
            }
            else return false;
        }
        return false;
    };

    policyMessage = () => {
        if(this.props.postedApplicationPage.postedApplication.policyStatus === 'Referred'){
            return <span>Your application has been <strong>Referred</strong> and you will be notified for the progress of your application.</span>
        }
        else if(this.props.postedApplicationPage.postedApplication.policyStatus === 'Live'){
            return <span>Your application has been accepted and the policy is now <strong>Live</strong></span>
        }
        else return null
    }

    render() {
        return (
            <PostedApplicationPage
                fetchingWording={this.props.fetchingWording}
                fetchingPostedApplicationMessage = {this.props.fetchingPostedApplicationMessage}
                wording={this.props.wording}
                postedApplicationMessage= {this.props.postedApplicationMessage}
                policyMessage={this.policyMessage}
                shouldRender={this.shouldRender}
                changeApplicationsAndPoliciesField={this.props.changeApplicationsAndPoliciesField}
                push={this.props.push}
                store={this.props.postedApplicationPage}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        postedApplicationPage: state.postedApplicationPage,
        router:state.router,
        wording: state.applicationPolicy.wording,
        fetchingWording: state.applicationPolicy.fetchingWording,
        postedApplicationMessage: state.submittedPolicy.postedApplicationMessage,
        fetchingPostedApplicationMessage: state.submittedPolicy.fetchingPostedApplicationMessage
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        push: (url) => {
            dispatch(push(url))
        },
        changeApplicationsAndPoliciesField: (key, value) => {
            dispatch(changeApplicationsAndPoliciesField(key, value))
        },
        getApplicationPolicyWording: (payload) => {
            dispatch(getApplicationPolicyWording(payload))
        },
        getApplicationPolicyIPID: (payload) => {
            dispatch(getApplicationPolicyIPID(payload))
        },
        getPostedApplicationMessage: (payload) => {
            dispatch(getPostedApplicationMessage(payload))
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PostedApplicationPageHOC);